import { ChildFields } from '../models/child';
import getFullName from './getFullName';
import { getValue } from '../constants/getFieldValues';

export function compareChild(
  child: ChildFields,
  otherChild: ChildFields
): number {
  return getFullName(child).toLowerCase() >
    getFullName(otherChild).toLowerCase()
    ? 1
    : -1;
}

export function isChildrenEqual(
  child: ChildFields,
  otherChild: ChildFields
): boolean {
  return (
    child.fullName === otherChild.fullName &&
    getValue(child.birthdate) === getValue(otherChild.birthdate)
  );
}
